import React, { useContext, useState } from 'react'
import appConfig from '../../../../../app.config'
import { useTranslation } from 'react-i18next'
import SspContext from '../../../../contexts/SspContext'
import { ICreditBalance } from '../../../../interfaces/i-api-creaditCard'
import getPinUrlService from '../../../../services/CreditCardServices/getPinUrlService'
import { checkIsMobile, getErrorWithFullMessage } from 'shared'
import { Heading } from '../../../../components/index'

import './ShowPin.scss'

const ShowPin = () => {
	const { t } = useTranslation()

	const { overviewData } = useContext(SspContext)
	const [creditCardData] = useState(overviewData as ICreditBalance)
	const [error, setError] = useState<Error>()
	const [loading, setLoading] = useState(false)
	const [url, setUrl] = useState('')

	const iframeHeight = {
		height: checkIsMobile() ? '300px' : '225px',
	}

	const showPin = async () => {
		setLoading(true)
		try {
			await getPinUrlService(creditCardData?.cardID, t)
				.then((response) => {
					setUrl(response.data.url + `&lang=${appConfig.country}`)
				})
				.finally(() => setLoading(false))
		} catch (error: any) {
			console.log(error)
			setLoading(false)
			setError(getErrorWithFullMessage(error))
		}
	}

	return (
		<div className="fade-in show-pin container d-flex justify-content-center">
			<div className="fixed-width my-5">
				<Heading
					title="ShowPinTitle"
					description="ShowPinDescription"
				/>
				<div className="show-pin-wrapper">
					<div className="mb-3">
						<iframe
							style={iframeHeight}
							className="form-control"
							src={url}
							title="showPin"></iframe>
						{error && <>{error.message}</>}
					</div>
					<div className="d-flex flex-row-reverse">
						<button
							className="btn btn-default"
							type="button"
							onClick={() => showPin()}>
							{loading ? (
								<div id="circle-spinner"></div>
							) : (
								t('ShowPIN')
							)}
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}
export default ShowPin
